import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { compose, setDisplayName } from 'react-recompose';
import { withHEAccountSubscriptions } from '../../utils/subscriptions';

const SubscriptionInActiveComponent = ({ allOf, heAccount, children }) =>
  heAccount && [].concat(allOf).every((sub) => !includes(heAccount.activeSubscriptions, sub)) && children;
const SubscriptionInActive = compose(
  setDisplayName('SubscriptionInactive'),
  withHEAccountSubscriptions,
)(SubscriptionInActiveComponent);
SubscriptionInActive.propTypes = {
  allOf: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
};
export default SubscriptionInActive;
